export default function normalizeAuthenticationResponse(res, token) {
  return {
    mustChangePassword: res.mustChangePassword,
    isTokenValid: res.success,
    token,
  };
}
